import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-dc-company-address-card',
    templateUrl: './dc-company-address-card.component.html',
    styleUrls: ['./dc-company-address-card.component.scss'],
    standalone: false
})
export class DcCompanyAddressCardComponent implements OnInit {
  @Output() clickedEdit = new EventEmitter<boolean>();
  @Input() leiData: any;

  constructor() {}

  ngOnInit(): void {}

  clickHandler() {
    this.clickedEdit.emit(true);
  }
}
